import React, { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';

// Store Provider for Redux
export const ProviderWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};
